// Generated types for ModularBreakdownTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ModularBreakdownTaskReadAPI extends TaskReadAPI {
}

export interface ModularBreakdownTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ModularBreakdownTaskReadAPISchema: z.ZodType<ModularBreakdownTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ModularBreakdownTaskWriteAPISchema: z.ZodType<ModularBreakdownTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
